import React from "react";

import globalStyles from "../../../../App.module.scss"
import styles from './BashEncryption.module.scss'
import Gist from "react-gist";

export default function BashEncryption() {
    return (
        <div className={styles.bashEncryption}>
            <h1>Encrypting and decrypting using openssl</h1>

            <h3>Method 1: Symmetric encryption</h3>

            <h4>Encrypt file</h4>
            <p className={globalStyles.code}>
                openssl enc -aes-256-cbc -pbkdf2 -e -in file.txt -out file.enc
            </p>

            <h4>Decrypt file</h4>
            <p className={globalStyles.code}>
                openssl enc -aes-256-cbc -pbkdf2 -d -in file.enc -out file.txt
            </p>

            <h4>Helper script</h4>

            <p>This script needs the next tools installed in the sytem:</p>
            <ul>
                <li>openssl</li>
                <li>tar</li>
            </ul>

            <p>This is encrypting the data using AES 256 cypher, password protected.</p>
            <div style={{maxWidth: '600px'}}><Gist id={"7c0e717028f9cf81e19cf45adc75b69b"}/></div>

            <h3>Method 2: Asymmetric encryption</h3>
            <p>The weakness of previous encryption method is that it uses symmetric encryption.
                That means that the same 'key' is used for encrypting and decrypting the data</p>
            <p>This method uses RSA asymmetric key pair. There is a public and a private key used.
                The a public key will be used to encrypt the data and the private key for decrypting it.</p>

            <h4>Generate private and public keys</h4>
            <p className={globalStyles.code}>openssl genrsa -out key.pem<br/>
                openssl rsa -in key.pem -out key.pub -pubout
            </p>

            <h4>Encrypt file</h4>
            <p className={globalStyles.code}>
                openssl rsautl -in file.txt -out file.enc -pubin -inkey key.pub -encrypt
            </p>

            <h4>Decrypt file</h4>
            <p className={globalStyles.code}>
                openssl rsautl -in file.enc -out file.txt -inkey key.pem -decrypt
            </p>

        </div>
    )
}
